module.exports = __webpack_public_path__ + "static/girl-83ea59547bde70111ec0a8073c3f58a5.jpg";